/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useContext} from "react";
import {Link} from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import TableHeader from "../Common/TableHeader";
import Loader from "../Common/Loader";
import CallContext from "../../Context/CallContext";
import Pagination from "../Common/Pagination";
import CallLogsSearchForm from "../Common/CallLogs/CallLogsSearchForm";
import CallLogsTable from "../Common/CallLogs/CallLogsTable";

function SchoolTwilioLogs() {
  const {schoolID, schoolTwilioLogsList, twilioCaller, twilioMeta, twilioPage, twilioEndDate, twilioStartDate, isRealTimeEnabled,
      isTwilioSearching, loading2, setTwilioPage, isFirstLoad, setIsRealTimeEnabled,
      setTwilioCaller, setIsTwilioSearching, setTwilioEndDate, setTwilioStartDate, getSchoolTwilioLogsList, searchSchoolTwilioLogs } = useContext(CallContext);

  useEffect(() => {
    if (isRealTimeEnabled) {
      const intervalId = setInterval(() => {
        if (!isTwilioSearching) {
          getSchoolTwilioLogsList(twilioPage);
        }
      }, 10000);
  
      return () => clearInterval(intervalId);
    }
  }, [twilioPage, isTwilioSearching, isRealTimeEnabled, schoolID]);

  const resetSearch = () => {
    setTwilioCaller("");
    setTwilioStartDate("");
    setTwilioEndDate("");
    setTwilioPage(1);
    setIsTwilioSearching(false);
    getSchoolTwilioLogsList(1); 
  };

  const exportToPDF = () => {
    const pdf = new jsPDF("p", "pt", "a4");
    const columns = ["Date & Time", "Call Status", "Caller Details", "Callee Details", "Duration", "Station", "Call Cost"];
    const data = schoolTwilioLogsList.map(item => [
      item.call_time,
      item.status,
      `${item.caller_name} (${item.caller_number})`,
      `${item.callee_name} (${item.callee_number})`,
      item.duration_format,
      `${item.station_name} (${item.school_name})`,
      `UGX. ${item.call_cost?.total_c}`,

    ]);

    pdf.autoTable({ head: [columns], body: data });
    pdf.save("twilio_call_logs.pdf");
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= twilioMeta) {
      setTwilioPage(newPage);
    }
  };

  useEffect(() => {
    if (twilioCaller || twilioStartDate || twilioEndDate) {
      searchSchoolTwilioLogs();
    } else {
      getSchoolTwilioLogsList(twilioPage);
    }
  }, [twilioPage, schoolID]);

  return (
    <>
      
      <div class="heading-layout1 mg-b-5">
        <TableHeader
          subtitle="List of all the buzz to other network calls sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={exportToPDF} ><i class="fas fa-file-export"></i>Export</Link>
            <Link class="dropdown-item" onClick={() => setIsRealTimeEnabled(!isRealTimeEnabled)} >{isRealTimeEnabled ?<i className="fa fa-toggle-on mr-1" style={{ color: "green" }}></i>:<i className="fa fa-toggle-off mr-1" style={{ color: "red" }}></i>}{isRealTimeEnabled ? "Real-Time Updates: ON" : "Real-Time Updates: OFF"}</Link>
          </div>
        </div>
      </div>

      <CallLogsSearchForm caller={twilioCaller} setCaller={setTwilioCaller} startDate={twilioStartDate}
         setStartDate={setTwilioStartDate} endDate={twilioEndDate} setEndDate={setTwilioEndDate} searchCallLogs={searchSchoolTwilioLogs}
         resetSearch={resetSearch} setPage={setTwilioPage}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {isFirstLoad || loading2 ? (
          <Loader /> 
        ) : (
          <CallLogsTable logsList={schoolTwilioLogsList} logType="twilio"/>
        )}
      </div>

      <Pagination currentPage={twilioPage} totalPages={twilioMeta} onPageChange={handlePagination}/>

    </>
  );
}

export default SchoolTwilioLogs;
